import { React } from '@digsup/core-ui';
import { Text } from '@digsup/components-text';
import PropTypes from 'prop-types';

const Title = ({ children, className }) => (
  <Text
    className={className}
    marginBottom="medium"
    tag="h2"
    fontWeight="semibold"
    size="medium">
    {children}
  </Text>
);

Title.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
};

Title.defaultProps = {};

export { Title };
